// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductCreatePage_container__3ZHcf","title":"ProductCreatePage_title__2nEg3"};